// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-087259d3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../vue-loader/lib/selector.js?type=styles&index=0!./PingPong.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("16b15d5d", content, false, {});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-087259d3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../vue-loader/lib/selector.js?type=styles&index=0!./PingPong.vue", function() {
     var newContent = require("!!../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-087259d3\",\"scoped\":true,\"hasInlineConfig\":false}!../../../sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../vue-loader/lib/selector.js?type=styles&index=0!./PingPong.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-style-loader!./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-087259d3","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./~/vue-loading-spinner/src/components/PingPong.vue
// module id = 5Oz8
// module chunks = 0